import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

export const CasinoGamesGridContainer = forwardRef(({ children }, ref) => {
    const {
        showStripsGridUI,
    } = useSelector((state) => state.app.config);

    const containerGridClassName = classNames({
        'asg-vertical__games-grid': true,
        'casino-vertical-grid': true,
        'casino-vertical-grid--strips-grid-ui': showStripsGridUI,
    });

    return (
        <div ref={ref}
            className={containerGridClassName}
        >
            {children}
        </div>
    );
});

CasinoGamesGridContainer.displayName = 'CasinoGamesGridContainer';

